import { createReducer } from '@reduxjs/toolkit';
import { TransactionMid } from '../types';
import { fetchTransactionMids } from './thunks';

export interface TransactionCostAnalysisState {
  transactionMids: {
    data: TransactionMid[];
    loading: boolean;
    count: number;
    currentPage: number;
  };
}

const initialState: TransactionCostAnalysisState = {
  transactionMids: {
    data: [],
    loading: false,
    count: 0,
    currentPage: 1,
  },
};

export const transactionCostAnalysisReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(fetchTransactionMids.pending, (state) => {
      state.transactionMids.loading = true;
    })
    .addCase(fetchTransactionMids.fulfilled, (state, action) => {
      state.transactionMids.data = action.payload.results.map((row, index) => ({
        ...row,
        id: `${row.transaction_id}-${row.currency_id}-${index}`,
      }));
      state.transactionMids.count = action.payload.count;
      state.transactionMids.loading = false;
    })
    .addCase(fetchTransactionMids.rejected, (state) => {
      state.transactionMids.loading = false;
    });
});
